var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "b-form-group",
            {
              staticClass: "o-label",
              attrs: {
                id: "observance-music-form-group",
                label: _vm.$t("ceremony.music.ceremonyMusic"),
                "label-for": "observance-music-1-input"
              }
            },
            [
              _c("musics-component", {
                attrs: { category: _vm.ceremonyMusicsType }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "b-form-group",
            {
              staticClass: "o-label",
              attrs: {
                id: "observance-music-form-group",
                label: _vm.$t("ceremony.music.ceremonyBand"),
                "label-for": "observance-music-1-input"
              }
            },
            [
              _c("musics-component", {
                attrs: { category: _vm.ceremonyBandsType }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "b-form-group",
            {
              staticClass: "o-label",
              attrs: {
                id: "observance-music-form-group",
                label: _vm.$t("ceremony.music.observanceMusic"),
                "label-for": "observance-music-1-input"
              }
            },
            [
              _c("musics-component", {
                attrs: { category: _vm.observanceMusicsType }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "b-form-group",
            {
              staticClass: "o-label",
              attrs: {
                id: "observance-music-form-group",
                label: _vm.$t("ceremony.music.observanceBand"),
                "label-for": "observance-music-1-input"
              }
            },
            [
              _c("musics-component", {
                attrs: { category: _vm.observanceBandsType }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f1f1f5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f1f1f5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/funeral/music/MusicsContainerComponent.vue
// module id = null
// module chunks = 